import { Injectable } from '@angular/core';
import { combineLatest, Observable, Subject } from 'rxjs';
import { ActiveFeaturesConfigcatService } from "~shared/modules/active-features/services";
import { OptimizelyService } from "~shared/services/optimizely.service";
import { CATEGORY_NAVIGATION_REDESIGN, FeatureToggleEnum } from "~shared/constants";

@Injectable({
  providedIn: 'root',
})
export class CategoryNavigationService {
  private _sidenavSubject = new Subject<void>();
  sidenav$ = this._sidenavSubject.asObservable();

  constructor(
    private featureFlagService: ActiveFeaturesConfigcatService,
    private optimizelyService: OptimizelyService,
  ) {}

  toggleSidenav(): void {
    this._sidenavSubject.next();
  }

  isSidenavMenuEnabled(): Observable<[boolean, string]> {
    return combineLatest([
      this.featureFlagService.isFeatureEnabled(FeatureToggleEnum.FF_MACO_NEW_NAVIGATION_MENU_ENABLE),
      this.optimizelyService.getExperimentVariant(CATEGORY_NAVIGATION_REDESIGN)
    ])
  }
}
